import React from "react";
import Layout from "./components/layout/Layout";
import ScheduleTabs from "./components/schedule/ScheduleTabs";
import UtilizationTab from "./components/utilization/UtilizationTab";
import ErrorBoundary from "./components/ui/ErrorBoundary";
import { Switch, Route, Redirect } from "react-router-dom";

import {
    AuthenticatedTemplate,
    UnauthenticatedTemplate,
} from "@azure/msal-react";


function App() {
      return (
        <ErrorBoundary>
        <Layout>
            <Switch>
                <Route path="/calendar">
                    <AuthenticatedTemplate>
                        <ErrorBoundary>
                            <ScheduleTabs defaultTab="calendar" />
                        </ErrorBoundary>
                    </AuthenticatedTemplate>
                    <UnauthenticatedTemplate>
                        <p>Please login...</p>
                    </UnauthenticatedTemplate>
                </Route>
                <Route path="/resources">
                    <AuthenticatedTemplate>
                        <ErrorBoundary>
                            <ScheduleTabs defaultTab="board" />
                        </ErrorBoundary>
                    </AuthenticatedTemplate>
                    <UnauthenticatedTemplate>
                        <p>Please login...</p>
                    </UnauthenticatedTemplate>
                </Route>
                <Route path="/utilization">
                    <AuthenticatedTemplate>
                        <ErrorBoundary>
                            <UtilizationTab />
                        </ErrorBoundary>
                    </AuthenticatedTemplate>
                    <UnauthenticatedTemplate>
                        <p>Please login...</p>
                    </UnauthenticatedTemplate>
                </Route>
                <Route exact path="/">
                    <AuthenticatedTemplate>
                        <h1>Welcome to the Project Ticketing System</h1>
                    </AuthenticatedTemplate>
                    <UnauthenticatedTemplate>
                        <p>Please login...</p>
                    </UnauthenticatedTemplate>
                </Route>
                <Redirect to="/" />
            </Switch>
        </Layout>
        </ErrorBoundary>
    );
}

export default App;
